/* eslint-disable max-lines */
import Upload from '../image-upload/image-upload.vue';
import VueCropper from 'vue-cropperjs';
import debounce from 'lodash-es/debounce';
const INVALID_IMAGE_GTM = 'bankCardPictureUploadInvalidImage';
const ZOOM_STEPS = 10;
const MAX_ZOOM = 3;
const CARD_TEXTS = {
	24: {
		isThruText: true,
		thruText: 'GOOD',
		hasCardNumberStart: true,
		isShadow: false
	},
	44: {
		thruText: 'GOOD',
		hasCardNumberStart: true,
		isShadow: false
	},
	45: {
		thruText: 'GOOD',
		hasCardNumberStart: false,
		isShadow: false
	},
	51: {
		thruText: 'VALID',
		hasCardNumberStart: false,
		isShadow: true
	}
};
const LIMITS = {
	isic: {
		minSize: 50 * 1024,
		minWidth: 300,
		minHeight: 300,
		maxSize: 3 * 1024 * 1024,
		maxWidth: 2048,
		maxHeight: 2048
	},
	nonIsic: {
		minSize: 600 * 1024,
		minWidth: 1030,
		minHeight: 670,
		maxSize: 5 * 1024 * 1024,
		maxWidth: 4044,
		maxHeight: 2552
	}
};
const DEBIT_CARD = {
	width: 417,
	height: 269
};
const ISIC_CARD = {
	width: 70,
	height: 70,
	left: 318,
	top: 68
};
const FRAME_ZOOM_PERCENTAGE = 0.93;
const MIN_ZOOM_LEVEL = 1 / FRAME_ZOOM_PERCENTAGE - 1;
export default {
	data() {
		return {
			file: null,
			editorVisible: false,
			uploadVisible: true,
			imgSrc: null,
			scaleX: 1,
			eventQueue: [],
			wheelZoomRatio: null,
			contextMask: null,
			undoZoomInProgress: false,
			cardText: null,
			error: null,
			minSize: null,
			minWidth: null,
			minHeight: null,
			maxSize: null,
			maxWidth: null,
			maxHeight: null,
			limit: null,
			loading: false,
			canvasWidth: null,
			canvasHeight: null,
			fontColors: [],
			fontColorIndex: 0,
			currentZoomRatio: 0,
			initZoom: true,
			initZoomRatio: 0,
			cropInProgress: false
		};
	},
	props: {
		cardData: Object
	},
	components: {
		upload: Upload,
		VueCropper
	},
	watch: {
		editorVisible(val) {
			if (val) {
				this.$nextTick(() => {
					this.loadMask();
				});
			}
		},
		editorVisibleNoError(val) {
			this.$emit('on-editor-visibility-change', val);
		}
	},
	computed: {
		editorVisibleNoError() {
			return !this.error && this.editorVisible;
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	methods: {
		setCanvasDimensions() {
			this.canvasWidth = this.isMobile ? 280 : 350;
			this.canvasHeight = this.isMobile ? 180 : 224;
		},
		onMove() {
			let canvasData = this.$refs.cropper.getCanvasData();
			this.eventQueue.push({
				action: 'move',
				value: {
					x: canvasData.left,
					y: canvasData.top
				}
			});
		},
		moveTo({ x, y }) {
			this.$refs.cropper.moveTo(x, y);
		},
		reset() {
			this.$refs.cropper.reset();
			this.eventQueue = [];
			this.setMinimumZoomLevel();
			this.resetFontColor();
		},
		mirror(e, undo) {
			// change sign of scaleX
			this.scaleX -= this.scaleX * 2;
			this.$refs.cropper.scaleX(this.scaleX);
			if (!undo) {
				this.eventQueue.push({ action: 'mirror', value: this.scaleX });
			}
		},
		rotate(e, undo) {
			if (!undo) {
				this.$refs.cropper.rotate(90);
				const cropperData = this.$refs.cropper.getData();
				if (cropperData.rotate == 0 || cropperData.rotate == 180) {
					this.zoomToRatio(this.currentZoomRatio);
				}
				this.eventQueue.push({ action: 'rotate', ratio: this.currentZoomRatio });
			} else {
				this.$refs.cropper.rotate(-90);
			}
		},
		zoom() {
			this.$refs.cropper.relativeZoom(MAX_ZOOM / ZOOM_STEPS);
		},
		unZoom() {
			this.$refs.cropper.relativeZoom(-(MAX_ZOOM / ZOOM_STEPS));
		},
		zoomToRatio(ratio) {
			this.undoZoomInProgress = true;
			this.$refs.cropper.zoomTo(ratio);
			this.currentZoomRatio = ratio;
		},
		changeFontColors(e, undo) {
			if (this.fontColorIndex < this.fontColors.length - 1) {
				this.fontColorIndex++;
			} else {
				this.fontColorIndex = 0;
			}
			if (!undo) {
				this.eventQueue.push({ action: 'changeFontColor' });
			}
			this.loadMask();
		},
		resetFontColor() {
			this.fontColorIndex = 0;
			this.loadMask();
		},
		onZoom(e) {
			if (e.detail.ratio > e.detail.oldRatio && e.detail.ratio > MAX_ZOOM) {
				e.preventDefault();
				return;
			} else if (e.detail.ratio < e.detail.oldRatio && !this.cropInProgress && e.detail.ratio < this.initZoomRatio) {
				e.preventDefault();
				this.$refs.cropper.zoomTo(this.initZoomRatio);
				return;
			}
			if (!this.undoZoomInProgress) {
				if (e.detail.ratio != e.detail.oldRatio) {
					const event = { action: 'zoom', value: e.detail.oldRatio };
					const index = this.eventQueue.length - 1;
					if (this.eventQueue[index]?.action != event.action || this.eventQueue[index]?.value != event.value) {
						this.eventQueue.push({ action: 'zoom', value: e.detail.oldRatio });
						this.currentZoomRatio = e.detail.ratio;
						this.initZoomRatio = this.initZoomRatio || e.detail.ratio;
					}
				}
			}
			this.undoZoomInProgress = false;
		},
		undo() {
			if (this.eventQueue.length) {
				let event = this.eventQueue.pop();
				switch (event.action) {
					case 'mirror':
						this.mirror(null, true);
						break;
					case 'rotate':
						this.rotate(null, true);
						this.zoomToRatio(event.ratio); // a forgatás belezoomol a képbe, hogy kitöltse a szélességet
						break;
					case 'zoom':
						this.zoomToRatio(event.value);
						break;
					case 'move':
						this.moveTo(event.value);
						break;
					case 'changeFontColor':
						this.changeFontColors(null, true);
						break;
					default:
				}
			}
		},
		crop() {
			this.$refs.cropper.cropper.crop();
			let largeImage = this.$refs.cropper.getCroppedCanvas({
				width: this.limit.maxWidth,
				height: this.limit.maxHeight
			});
			this.cropInProgress = true;
			const containerData = this.$refs.cropper.getContainerData();
			this.$refs.cropper.zoomTo(this.currentZoomRatio * FRAME_ZOOM_PERCENTAGE, {
				x: containerData.width / 2,
				y: containerData.height / 2
			});
			this.$refs.cropper.cropper.crop();
			let largeImageUnZoomed = this.$refs.cropper.getCroppedCanvas({
				width: this.limit.maxWidth,
				height: this.limit.maxHeight
			});
			let maskedCanvas = document.createElement('canvas');
			maskedCanvas.width = DEBIT_CARD.width;
			maskedCanvas.height = DEBIT_CARD.height;
			let maskedContext = maskedCanvas.getContext('2d');
			if (this.cardData.isic) {
				maskedContext.drawImage(
					largeImage,
					0,
					0,
					largeImage.width,
					largeImage.height,
					ISIC_CARD.left,
					ISIC_CARD.top,
					ISIC_CARD.width,
					ISIC_CARD.height
				);
				maskedContext.drawImage(this.$refs.mask, 0, 0, this.canvasWidth, this.canvasHeight, 0, 0, DEBIT_CARD.width, DEBIT_CARD.height);
			} else {
				maskedContext.drawImage(largeImage, 0, 0, largeImage.width, largeImage.height, 0, 0, maskedCanvas.width, maskedCanvas.height);
				maskedContext.drawImage(this.$refs.mask, 0, 0, this.$refs.mask.width, this.$refs.mask.height, 0, 0, DEBIT_CARD.width, DEBIT_CARD.height);
			}

			this.sendCroppedImages(this.canvasImageToDataUrl(largeImageUnZoomed), this.canvasImageToDataUrl(maskedCanvas));
			this.$refs.cropper.clear();
		},
		canvasImageToDataUrl(canvas) {
			return canvas.toDataURL('image/jpeg');
		},
		sendCroppedImages(cropped, masked) {
			this.$emit('on-images-sent', { cropped, masked, original: this.imgSrc, textColor: this.fontColors[this.fontColorIndex] || '' });
		},
		validateFile(file) {
			// if the file was not an image
			if (!file.type.includes('image/')) {
				this.error = {
					format: true
				};
				return false;
			}
			// if the file size is too small
			if (file.size < this.limit.minSize) {
				this.error = {
					sizeTooSmall: true
				};
				return false;
			}
			// if the file size is too big
			if (file.size > this.limit.maxSize) {
				this.error = {
					sizeTooBig: true
				};
				return false;
			}
			return true;
		},
		validateImage(image) {
			// if the image size was too small
			if (image.naturalWidth < this.limit.minWidth) {
				this.error = {
					widthTooSmall: true
				};
				return false;
			}
			// if the image size was too big
			if (image.naturalWidth > this.limit.maxWidth) {
				this.error = {
					widthTooBig: true
				};
				return false;
			}
			// if the image size was too small
			if (image.naturalHeight < this.limit.minHeight) {
				this.error = {
					heightTooSmall: true
				};
				return false;
			}
			// if the image size was too big
			if (image.naturalHeight > this.limit.maxHeight) {
				this.error = {
					heightTooBig: true
				};
				return false;
			}
			return true;
		},
		setMinimumZoomLevel() {
			this.$refs.cropper.relativeZoom(MIN_ZOOM_LEVEL);
		},
		ready() {
			this.setMinimumZoomLevel();
		},
		setImage(file) {
			this.loading = true;
			if (this.validateFile(file)) {
				const reader = new FileReader();
				reader.onload = (event) => {
					let image = new Image();
					image.onload = () => {
						if (this.validateImage(image)) {
							this.showEditor();
							this.loading = false;
							this.imgSrc = event.target.result;
							// rebuild cropperjs with the updated source
							this.$nextTick(() => {
								this.$refs.cropper.replace(event.target.result);
							});
						} else {
							this.$gtm.trackEvent({
								event: INVALID_IMAGE_GTM
							});
						}
					};
					image.src = event.target.result;
				};
				reader.readAsDataURL(file);
			} else {
				this.$gtm.trackEvent({
					event: INVALID_IMAGE_GTM
				});
			}
		},
		startUpload() {
			this.editorVisible = false;
			this.uploadVisible = true;
			this.loading = false;
			this.error = null;
		},
		showEditor() {
			this.editorVisible = true;
			this.uploadVisible = false;
		},
		onUpload(file) {
			this.setImage(file.raw);
		},
		loadMask: debounce(function () {
			if (this.$refs.mask) {
				this.setCanvasDimensions();
				let contextMask = (this.contextMask = this.$refs.mask.getContext('2d'));
				contextMask.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
				var imageObj = new Image();
				imageObj.src = this.cardData.imageMaskUrl;
				let _self = this;
				imageObj.onload = function () {
					contextMask.drawImage(this, 0, 0, this.naturalWidth, this.naturalHeight, 0, 0, _self.canvasWidth, _self.canvasHeight);
					_self.writeTexts();
				};
			}
		}, 300),
		writeTexts() {
			if (this.fontColors) {
				this.contextMask.fillStyle = this.fontColors[this.fontColorIndex];
			}
			if (this.cardData.isic) {
				this.contextMask.font = (this.isMobile ? '19' : '25') + 'px Arial';
				this.contextMask.fillText('1234 5678 9012 3456'.split('').join(String.fromCharCode(8202)), this.canvasWidth / 10, this.canvasHeight / 1.5);
				this.contextMask.font = (this.isMobile ? '4' : '6') + 'px Arial';
				this.contextMask.font = (this.isMobile ? '10' : '13') + 'px Arial';
				this.contextMask.fillText('00/00', this.canvasWidth / 2.25, this.canvasHeight / 1.27);
				this.contextMask.fillText('05/08/1994', this.canvasWidth / 12, this.canvasHeight / 1.27);
				this.contextMask.fillText('UNIVERSITY NAME', this.canvasWidth / 12, this.canvasHeight / 1.15);
				this.contextMask.fillText('KÁRTYABIRTOKOS NEVE', this.canvasWidth / 12, this.canvasHeight / 1.05);
			} else {
				this.contextMask.font = (this.isMobile ? '19' : '25') + 'px Arial';
				this.contextMask.fillText('1234 5678 9012 3456'.split('').join(String.fromCharCode(8202)), this.canvasWidth / 10, this.canvasHeight / 1.6);
				this.contextMask.font = (this.isMobile ? '4' : '6') + 'px Arial';
				this.contextMask.font = (this.isMobile ? '14' : '18') + 'px Arial';
				this.contextMask.fillText('00/00', this.canvasWidth / 9.4, this.canvasHeight / 1.26);
				this.contextMask.fillText('KÁRTYABIRTOKOS NEVE', this.canvasWidth / 12, this.canvasHeight / 1.08);
			}
		}
	},
	created() {
		this.wheelZoomRatio = MAX_ZOOM / ZOOM_STEPS;
		this.cardText = CARD_TEXTS[this.cardData.cardId];
		this.limit = LIMITS[this.cardData.isic ? 'isic' : 'nonIsic'];
		if (this.cardData.imageFontColors) {
			this.fontColors = this.cardData.imageFontColors.trim().split(',');
		}
		this.setCanvasDimensions();
	},
	mounted() {
		window.addEventListener('resize', this.loadMask);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.loadMask);
	}
};
/* eslint-enable max-lines */
